import { render } from "./FileManagerContent.vue?vue&type=template&id=bf5088c8"
import script from "./FileManagerContent.vue?vue&type=script&lang=js"
export * from "./FileManagerContent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__